import {autoShipEvent, doseTypeChangeEvent, packagingTypeChange, supplementOrderControlInteraction} from './events';
import $ from 'jquery';
import colicareModals from '../../../colicare/modals';
import events from '../shared/events';
import namespace from '../../../smartpak/smartpak';
import orderForm from '../shared/orderform';
import smartPaksOrderForm from './smartpaksorderform.common';
import { tooltipProxy as tooltip } from '../../../smartpak/tooltipproxy';
import wishList from '../wishlist';
import spAddToWishList from '../../../vendor/googletagmanager/spevents/spaddtowishlist';
import { formatViewModelForEvent } from '../shared/formatviewmodelforevent';

const orderControl = {
        _initTooltips: function() {
            $('.submitOrderForm .tooltipTrigger, .lowestPriceTooltip').off();

            tooltip($('.submitOrderForm .tooltipTrigger'), {
                trigger: 'click',
                content: $('.asCopy').html(),
                placement: 'left',
                width: '300px'
            });

            tooltip($('.lowestPriceTooltip'), {
                trigger: 'click',
                content: $('.lowestPriceCopy').html(),
                placement: 'left'
            });
        },
        _bindEvents: function() {
            $(document).on('click', '#newFeedingChartLink', function(e) {
                e.preventDefault();
                smartPak.ui.modal($('#portionPakFeedingChart').get(0), {title: 'Feeding Chart'});
            });
        },
        _resetWishlist: function() {
            $('.wishlistLink').off('click', 'a');
        },
        _resetPreferredZipCodeModal: function() {
            $(document).off('click', '.preferredZipCode');
        },
        _bindPreferredZipCodeModal: function() {
            $('#productClassCon')
            .off('click', '.preferredZipCode')
            .on('click', '.preferredZipCode', function(e) {
                e.preventDefault();
                smartPak.zipCode._getPreferredZipCodeView();
            });
        },
        initEtaMessaging: function() {
            return smartPak.customerInfo.getCustomerInfo().done(
                function(response) {
                    if (
                        response &&
                        response.status === smartPak.HTTP_STATUS_OK &&
                        response.content.initialUserLocation
                    ) {
                        this._populateEtaMessaging(response.content.initialUserLocation);
                        this._bindPreferredZipCodeModal();

                        this._waitForZipCode(function() {
                            smartPak.zipCode._initialTimeSet('', smartPak.zipCode._getPreferredDeadline(response.content.initialUserLocation.cutOffTime));
                        });
                    }
                }.bind(this)
            );
        },
        _populateEtaMessaging: function(initialUserLocation) {
            $('.preferredCityState').html(initialUserLocation.city + ', ' + initialUserLocation.state);
            $('.preferredDate').html(initialUserLocation.deliveryBy);

            this._waitForZipCode(function() {
                smartPak.zipCode._initializeClock(
                    smartPak.zipCode._getPreferredDeadline(initialUserLocation.cutOffTime)
                );
            });

            if (initialUserLocation.zipCode !== smartPak.preferredLocationCookie.PreferredZipCode) {
                smartPak.preferredLocationCookie.refreshCookieData();

                if (smartPak.productClassViewModel && smartPak.productClassViewModel.updateEstimatedArrivalDates) {
                    smartPak.productClassViewModel.updateEstimatedArrivalDates();
                }
            }
        },
        _resetEvents: function() {
            $('.addToCartSubmit, #addSmartPakForm, .submitOrderForm').off('submit');
            $(document).off('click', '.PCColiCareHelpLink.tooptipIcon, .asTip .tooltipTrigger');
            $('#selectPackagingLink').off('click touchstart');
            this._resetWishlist();
            this._resetPreferredZipCodeModal();

            if (this.autoShipSubscribeInstances) {
                this.autoShipSubscribeInstances.forEach(function(instance) {
                    instance.dispose();
                });

                this.autoShipSubscribeInstances = null;
            }

            if (this.selectedProductSubscribe) {
                this.selectedProductSubscribe.dispose();
                this.selectedProductSubscribe = null;
            }
        },
        _mobilePackingOptionsModal: function() {
            var packagingOptionsModal,
                dialogOptions = {
                    title: 'Choose your packaging option',
                    modal: 'true',
                    resizable: false,
                    modalClass: 'mobile-slide-out'
                };

            $('#selectPackagingLink')
                .off('click')
                .on('click', function(e) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }

                    packagingOptionsModal = smartPak.ui.modal($('#packagingOptionsModal').get(0), dialogOptions);

                    $('#packagingOptionsModal')
                        .off('click', '.packingOption')
                        .one('click', '.packingOption', function() {
                            packagingOptionsModal.close();
                        });

                    $('.secondary.button.sp-modal-close')
                        .on('click', function() {
                            packagingOptionsModal.close();
                        });
                });
        },
        _waitForZipCode: function(callback) {
            var attempts = 0,
                wait = function() {
                    if (attempts > 30) {
                        return;
                    }

                    if (smartPak.zipCode) {
                        callback();
                    } else {
                        setTimeout(wait, 200);
                    }

                    attempts++;
                };

            wait();
        },
        init: function(productClassViewModel, isMobile) {
            this._resetEvents();

            orderForm.init($('.addToCartSubmit'), productClassViewModel, isMobile);

            if (!productClassViewModel.isCanine) {
                smartPaksOrderForm.init($('#addSmartPakForm'), productClassViewModel);
            } else if (productClassViewModel.hasSmartPak) {
                smartPaksOrderForm.init($('#addPortionPakForm'), productClassViewModel);
            } else if (productClassViewModel.hasPortionPak || productClassViewModel.hasPortionPakWithDosing) {
                this._bindEvents();
                smartPaksOrderForm.init($('#addPortionPakForm'), productClassViewModel);
            }

            if(productClassViewModel.hasSmartPak && productClassViewModel.smartPakableProduct){
                productClassViewModel.smartPakableProduct.selectedDoseTypeId.subscribe(id => doseTypeChangeEvent(id));
            }

            this._initTooltips();
            this._bindPreferredZipCodeModal();

            wishList.init(() => spAddToWishList(formatViewModelForEvent(ko.toJS(productClassViewModel))));
            colicareModals.init();

            this._mobilePackingOptionsModal();

            $(document).on('.asTip .tooltipTrigger', 'click', function() {
                supplementOrderControlInteraction('AutoShip details click');
            });

            $('#addSmartPakForm').on('submit', function() {
                if (!productClassViewModel.selectedRecipientName()) {
                    events._gaEvent('ProductClass', 'Validation Error', 'Recipient Error');
                }
            });

            this.autoShipSubscribeInstances = productClassViewModel.products().map(
                function(product) {
                    return product.isAutoShip.subscribe(
                        function(isAutoShip){
                            if(productClassViewModel.selectedProductId() && product.id() === productClassViewModel.selectedProductId()){
                                if (product.isTes && isAutoShip) {
                                    supplementOrderControlInteraction('AutoShip checkbox select');
                                }
    
                                autoShipEvent(isAutoShip);
                            }

                            requestAnimationFrame(
                                function() {
                                    this._initTooltips();
                                    this._resetWishlist();
                                    this._resetPreferredZipCodeModal();
                                    this.initEtaMessaging();
                                }.bind(this)
                            );
                        }.bind(this)
                    );
                }.bind(this)
            );

            this.selectedProductSubscribe = productClassViewModel.selectedProduct.subscribe(
                function(product) {
                    $('.forRecipientMessage').hide();
                    this._resetPreferredZipCodeModal();

                    if (product) {
                        var name = product.isTes
                            ? product.displayName()
                            : product.isSmartPak
                            ? 'Daily Dose SmartPaks'
                            : product.isPortionPak
                            ? 'Daily Dose PortionPaks'
                            : '';

                        if (!name) {
                            return;
                        }

                        packagingTypeChange(name);

                        requestAnimationFrame(
                            function() {
                                this.init(productClassViewModel, isMobile);
                                this.initEtaMessaging();
                            }.bind(this)
                        );
                    }
                }.bind(this)
            );
        }
    },
    productClass = namespace('productClass');

// make global namespace for dy actions
productClass.orderControl = orderControl;
productClass.smartPaksOrderForm = smartPaksOrderForm;

export default orderControl;
